<template>
<div class='home'>
  <div class='header'>
    <div class='back-btn' @click='goBack' v-if="partner">
      <div class='back-text'>返回</div>
    </div>
    <div class="header-content">  
      <div v-if="!partner" class='icon'></div>
      <div v-if="!partner" class='name'>温暖医生</div>
    </div>
  </div>
  <div v-if="!partner">
  <div class='menu1'>
    <div class='left' @click='cardsShow'>
      <div class='icon'></div>
      <div class='name'>视频卡和优惠券</div>
    </div>
    <div class='line'></div>
    <div class='right' @click='gotoyuyue'>
      <div class='icon'></div>
      <div class='name'>我的预约</div>
    </div>
  </div>
  <div class='menu2'>
    <div class='left' @click='activeCard'>
      <div class='icon'></div>
      <div class='name'>激活视频卡</div>
    </div>
    <div class='line'></div>
    <div class='right' @click='doclist'>
      <div class='icon'></div>
      <div class='name'>预约专家</div>
    </div>
  </div>
</div>
<div v-else>
  <div class='menu2'>
    <div class='right' @click='gotoyuyue'>
      <div class='icon'></div>
      <div class='name'>我的预约</div>
    </div>
    <div class='line'></div>
    <div class='right' @click='doclist'>
      <div class='icon'></div>
      <div class='name'>预约专家</div>
    </div>
  </div>
</div>
  <div v-if="!partner" class='footer'>
    <div class='icon'></div>
    <div class='name'>联系客服: 021-60662922</div>
  </div>
  <confirm ref="confirm" confirmBtnText="确认登录" @confirm="confirmClick">
    <div class='confirm-wrapper'>
      <cube-input placeholder='请输入手机号' type='number' v-model="phone" ></cube-input>
    </div>
  </confirm>
  <div v-if="partner" class='floating-text'>
    本服务由【第医视频】提供
  </div>
</div>
</template>

<script>
import Confirm from '../../components/confirm'
import { loginByPhone } from '../../api/loginApi'
import { getUserId, saveMxActiveNum, saveCacheObject } from '@/common/js/cache'

export default {
  name: 'Home',
  components: {
    Confirm
  },
  data() {
    return {
      login: '',
      phone: '',
      partner:false,
      activeNum: '',
      pt: '',
      backUrl: this.$route.query.backUrl,
      mxstatus:false,
      userName: '',
    }
  },
  created () {
    this.activeNum = this.$route.query.activeNum
    this.pt = this.$route.query.pkey
    this.backUrl = this.$route.query.backUrl
    this.userName = this.$route.query.userName

    if (this.pt === '~a01akcbbc7aaao'){
      this.partner = true
      this.mxstatus = true
      this.phone = this.$route.query.phone
      if (this.activeNum && this.userName && this.phone) {
       saveMxActiveNum(this.activeNum)
       saveCacheObject("__userName__", this.userName)
       saveCacheObject("__userPhone__", this.phone)
      }else{
       this.$createDialog({
         type: 'alert',
         title: '提示',
         content: '缺少链接订单参数'
       }).show()
       return
      }
    }
    if(this.$route.query.phone){
      this.phone = this.$route.query.phone
      this.confirmClick()
    }
  },
  mounted () {
    if (!getUserId()) this.$refs.confirm.show()
  },
  methods:{
    async confirmClick() {
      if (this.phone.length !== 11){
        this.$createDialog({
          type: 'alert',
          title: '提示',
          content: '请输入正确的手机号'
        }).show()
        return
      } 
      const res = await loginByPhone({
        phone: this.phone
      })
      if (res.code == 9000200){
        this.$refs.confirm.hide()
      }
      console.log(res)
    },
    cardsShow(){
     // window.location.href =  `http://cardrecord.warmdoctor.cn/mycard/dist/#/cards?userId=${getUserId()}&type=1`
      window.location.href =  `https://warm.xcx.warmdoctor.cn/mycard/dist/#/cards?userId=${getUserId()}&type=1`
    },
    gotoyuyue () {
      this.$router.push({
        path: '/orderList'
      })
    },
    activeCard(){
      this.$router.push({
        path: '/active'
      })
    },
    doclist(){
      if(this.pt === '~a01akcbbc7aaao' && !this.activeNum){
        this.$createDialog({
          type: 'alert',
          title: '提示',
          content: '缺少链接订单参数'
        }).show()
        return
      }
      this.$router.push({
        path: '/doclist'
      })
    },
    goBack() {
      window.location.href = this.backUrl
    },
  }

}
</script>

<style  lang="stylus"  scoped>
@import '../../common/stylus/mixin';
  .home{
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    .header{
      display: flex;
      flex-direction: row;
      align-items:center
      justify-content: space-between
      padding: 0 15px
      margin 30px auto
      .back-btn {
        display: flex
        align-items: center
        background-color: #faef5b
        border-radius: 15px
        padding: 5px 10px
        cursor: pointer
        margin-top: -20px
        .back-text {
          font-size: 14px
          color: black
          font-weight: bold
        }
      }
      .header-content {
        display: flex
        flex-direction: column
        align-items: center
        flex: 1
        margin-left: 10px
      }
      .icon {
        bg-image('../../assets/icon.png')
        background-size 80px,80px;
        width: 80px;
        height: 80px;
        border-radius 40px
      }
      .name {
        font-size 15px
        color white
        line-height 30px
      }
    }
    .menu1,.menu2{
      display flex
      background-color white
      margin 8px 10px
      padding 10px 0
      border-radius 5px
      align-items:center;
      .left ,.right{
        flex 1
        display flex
        justify-content center
        align-items:center;
        .name{
          margin-left 3PX
          font-size 18px
        }
      }
      .line {
        flex: 0 0 4px
        height 50px
        background: #dedede
        border-radius 2px
      }
    }
    .menu2{
      background-color #faef5b
    }
    .menu1 .left .icon  {
      bg-image('../../assets/home_icon2.png')
      background-size 30px 20px;
      width: 30px;
      height: 20px;
    }
    .menu1 .right .icon  {
      bg-image('../../assets/home_icon1.png')
      background-size 25px,25px;
      width: 25px;
      height: 25px;
    }.menu2 .left .icon  {
       bg-image('../../assets/home_icon3.png')
       background-size 25px,25px;
       width: 25px;
       height: 25px;
     }.menu2 .right .icon  {
        bg-image('../../assets/home_icon4.png')
        background-size 25px,25px;
        width: 25px;
        height: 25px;
      }
    .footer {
      display flex
      align-items:center;
      border-top 1PX solid rgba(255,255,255,0.3)
      border-bottom 1PX solid rgba(255,255,255,0.3)
      padding 10px
      margin-top 10px
      .icon  {
        bg-image('../../assets/home_icon5.png')
        background-size 25px,25px;
        width: 25px;
        height: 25px;
      }
      .name{
        font-size 18px
        color  white
        padding-left 10px
      }
    }
    .confirm-wrapper{
      padding 20px 10px

    }
    .floating-text {
      position fixed
      bottom 20px
      left 0
      right 0
      text-align center
      color white
      font-size 14px
      padding 10px
      z-index 999
    }
  }
</style>
